var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showLeft,
            expression: "showLeft",
          },
        ],
        staticClass: "left_tree",
      },
      [
        _c(
          "a-spin",
          {
            staticStyle: { height: "100%" },
            attrs: { spinning: _vm.treeSpin },
          },
          [
            _c(
              "div",
              [
                _c(
                  "a-radio-group",
                  {
                    on: { change: _vm.handleChange },
                    model: {
                      value: _vm.type,
                      callback: function ($$v) {
                        _vm.type = $$v
                      },
                      expression: "type",
                    },
                  },
                  [
                    _c("a-radio-button", { attrs: { value: "dept" } }, [
                      _vm._v(" 部门 "),
                    ]),
                    _c("a-radio-button", { attrs: { value: "customer" } }, [
                      _vm._v(" 员工 "),
                    ]),
                  ],
                  1
                ),
                _c(
                  "a-button",
                  {
                    staticStyle: { "margin-top": "12px" },
                    on: { click: _vm.closeAll },
                  },
                  [_vm._v("清空")]
                ),
              ],
              1
            ),
            _vm.type === "dept"
              ? _c(
                  "div",
                  { staticClass: "tree-box" },
                  [
                    _c(
                      "a-tree",
                      {
                        attrs: {
                          "show-icon": true,
                          checkable: "",
                          "expanded-keys": _vm.expandedKeys,
                          "auto-expand-parent": _vm.autoExpandParent,
                          "selected-keys": _vm.selectedKeys,
                          "tree-data": _vm.treeData,
                          selectable: false,
                          replaceFields: {
                            children: "children",
                            title: "deptName",
                            key: "deptId",
                          },
                        },
                        on: { expand: _vm.onExpand, check: _vm.onSelect },
                        model: {
                          value: _vm.checkedKeys,
                          callback: function ($$v) {
                            _vm.checkedKeys = $$v
                          },
                          expression: "checkedKeys",
                        },
                      },
                      [
                        _c("a-icon", {
                          staticStyle: { color: "#2fcfeb" },
                          attrs: { slot: "dealer", type: "team" },
                          slot: "dealer",
                        }),
                        _c("a-icon", {
                          staticStyle: { color: "#52c41a" },
                          attrs: { slot: "region", type: "cluster" },
                          slot: "region",
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.type === "customer"
              ? _c(
                  "div",
                  { staticClass: "tree-box" },
                  [
                    _c("Tree", {
                      attrs: {
                        list: _vm.treeData,
                        selectedUser: _vm.selectedUser,
                        userName: "",
                        detph: 0,
                      },
                      on: { change: _vm.checkedUser },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "right_table", class: { showLeft: !_vm.showLeft } },
      [
        _vm.showLeft
          ? _c("a-icon", {
              staticClass: "close",
              staticStyle: { display: "none!important" },
              attrs: { type: "left-circle" },
              on: {
                click: function ($event) {
                  _vm.showLeft = false
                },
              },
            })
          : _c("a-icon", {
              staticClass: "close",
              staticStyle: { display: "none!important" },
              attrs: { type: "right-circle" },
              on: {
                click: function ($event) {
                  _vm.showLeft = true
                },
              },
            }),
        _c("div", { staticClass: "report_query_box" }, [
          _vm.searchDateRangeShow
            ? _c(
                "div",
                { staticClass: "item_box" },
                [
                  _c("span", [_vm._v("日期：")]),
                  _c("a-range-picker", {
                    staticStyle: { width: "350px" },
                    attrs: {
                      "default-value": _vm.dateDefaultDate,
                      format: _vm.dateFormat,
                    },
                    on: { change: _vm.onChangeDate },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "item_box" },
            [
              _c("span", [_vm._v("品系：")]),
              _c("a-select", {
                staticStyle: { width: "150px" },
                attrs: { options: _vm.strainOptions },
                model: {
                  value: _vm.search.strainName,
                  callback: function ($$v) {
                    _vm.$set(_vm.search, "strainName", $$v)
                  },
                  expression: "search.strainName",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "item_box" },
            [
              _c("span", [_vm._v("经理部：")]),
              _c("a-select", {
                staticStyle: { width: "150px" },
                attrs: { options: _vm.regionOptions },
                on: { change: _vm.changeRegionId },
                model: {
                  value: _vm.search.regionId,
                  callback: function ($$v) {
                    _vm.$set(_vm.search, "regionId", $$v)
                  },
                  expression: "search.regionId",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "item_box" },
            [
              _c("span", [_vm._v("经销商：")]),
              _c("a-select", {
                staticStyle: { width: "150px" },
                attrs: { "show-search": "", options: _vm.dealerOptions },
                model: {
                  value: _vm.search.dealerName,
                  callback: function ($$v) {
                    _vm.$set(_vm.search, "dealerName", $$v)
                  },
                  expression: "search.dealerName",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "report_query_btns" },
            [
              _c(
                "a-button",
                {
                  staticClass: "func_btn_item",
                  attrs: { type: "primary" },
                  on: { click: _vm.searchData },
                },
                [_vm._v("筛选")]
              ),
              _c(
                "a-button",
                { staticClass: "func_btn_item", on: { click: _vm.resetData } },
                [_vm._v("重置")]
              ),
              _c(
                "a-dropdown",
                [
                  _c(
                    "a-menu",
                    { attrs: { slot: "overlay" }, slot: "overlay" },
                    [
                      _c(
                        "a-menu-item",
                        {
                          key: "1",
                          on: {
                            click: function ($event) {
                              return _vm.exportData("current")
                            },
                          },
                        },
                        [
                          _c("a-icon", { attrs: { type: "export" } }),
                          _vm._v(" 导出当前 "),
                        ],
                        1
                      ),
                      _c(
                        "a-menu-item",
                        {
                          key: "2",
                          on: {
                            click: function ($event) {
                              return _vm.exportData("all")
                            },
                          },
                        },
                        [
                          _c("a-icon", { attrs: { type: "export" } }),
                          _vm._v(" 导出全部 "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    {
                      staticClass: "func_btn_item",
                      attrs: { type: "primary" },
                    },
                    [
                      _vm._v(" 导出 "),
                      _c("a-icon", { attrs: { type: "down" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("a-table", {
          attrs: {
            columns: _vm.columns,
            "data-source": _vm.tableData,
            pagination: _vm.pagination,
            bordered: "",
            loading: _vm.loading,
            size: "middle",
            scroll: { x: "calc(700px + 50%)", y: 600 },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }